import * as actionTypes from './action-types';
import { STORES_GROUPS_TYPE } from '../../utils/types';

type StateType = {
  readonly currentTab: string;
  readonly errorMessage: string;
};

const initialState: StateType = {
  currentTab: STORES_GROUPS_TYPE,
  errorMessage: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TAB_SELECT:
      return {
        ...state,
        currentTab: action.payload,
      };
    case actionTypes.ERROR_MESSAGE_SET:
      return {
        ...state,
        errorMessage: action.payload,
      };
    case actionTypes.VIEW_GROUP:
      return {
        ...state,
        groupId: action.payload,
        show: true,
      };
    case actionTypes.GROUP_SET:
      return {
        ...state,
        details: {
          name: action.payload.name,
          context: action.payload.context,
          accounts: action.payload.data.accounts !== null ? action.payload.data.accounts : [],
          items: action.payload.data.items !== null ? action.payload.data.items : [],
          stores: action.payload.data.stores !== null ? action.payload.data.stores : [],
          states: action.payload.data.states !== null ? action.payload.data.states : [],
        },
      };
    case actionTypes.SHOW_SET:
      return {
        ...state,
        show: action.payload,
      };
    case actionTypes.SHOW_DELETE_SET:
      return {
        ...state,
        showDelete: action.payload,
      };
    case actionTypes.DELETE_GROUP:
      return {
        ...state,
        groupId: action.payload.id,
        context: action.payload.context,
        showDelete: true,
      };
    case actionTypes.DELETE_FAV:
      return {
        ...state,
        favId: action.payload.id,
        name: action.payload.name,
        showDelete: true,
      };
    default:
      return state;
  }
};

export default reducer;
